import { useRef, type MouseEvent, type PointerEvent } from 'react';

/** A drag's compatibility click must not select the document underneath it. */
export function useSwipeClickGuard() {
  const start = useRef<{ x: number; y: number } | null>(null);
  const dragged = useRef(false);

  return {
    onPointerDownCapture: (event: PointerEvent<HTMLElement>) => {
      start.current = { x: event.clientX, y: event.clientY };
      dragged.current = false;
    },
    onPointerMoveCapture: (event: PointerEvent<HTMLElement>) => {
      if (start.current && Math.hypot(
        event.clientX - start.current.x, event.clientY - start.current.y,
      ) > 6) dragged.current = true;
    },
    onDragStart: () => { dragged.current = true; },
    onClickCapture: (event: MouseEvent<HTMLElement>) => {
      // Keyboard/assistive activation has no pointer click count. A new real
      // tap resets the guard on pointerdown, without an arbitrary timeout.
      if (dragged.current && event.detail !== 0) {
        event.preventDefault();
        event.stopPropagation();
      }
      start.current = null;
    },
  };
}
